import { render, staticRenderFns } from "./theEdit.vue?vue&type=template&id=0c89adec&scoped=true"
import script from "./theEdit.vue?vue&type=script&lang=js"
export * from "./theEdit.vue?vue&type=script&lang=js"
import style0 from "./theEdit.vue?vue&type=style&index=0&id=0c89adec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c89adec",
  null
  
)

export default component.exports